module.exports = __webpack_public_path__ + "70fbd18de630b2e8fe699ddd4d54fd77.png";